import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'EmailRedirection';
const ENDPOINT = `/email-redirections/`;

@Injectable({
    providedIn: 'root'
})
export class EmailRedirectionService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
